<div class="contract-renewal-card-plugin" hive-root>
    <img src="{{ renderInfo().contractImgUrl }}" />
    <div class="contract-renewal-card-plugin__body" [attr.data-emphasis]="renderInfo().emphasis">
        <hive-label [label]="renderInfo().headline"></hive-label>
        <div class="contract-renewal-card-plugin__days-remaining">
            <hive-label label="Expires in" size="smallest"></hive-label>
            <hive-label
                class="contract-renewal-card-plugin__days-remaining-num"
                [label]="renderInfo().daysRemaining"
                weight="semibold"
            ></hive-label>
            <hive-label label="Day(s)" size="smallest"></hive-label>
        </div>
    </div>
    @if (renderInfo().termDetails) {
        <hive-label
            class="contract-renewal-card-plugin__footer"
            [label]="renderInfo().termDetails"
            size="smallest"
        ></hive-label>
    }
</div>
